// Normalize a URL so it's safe to open in a new tab.
// - Adds https:// if the user pasted a bare domain (e.g. "drive.google.com/..." )
// - Returns null for non-URL strings
export function normalizeUrl(raw) {
  if (!raw || typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  if (/^(https?:|mailto:|tel:)/i.test(trimmed)) return trimmed;
  if (/^[\w-]+(\.[\w-]+)+/.test(trimmed)) return `https://${trimmed}`;
  return null;
}

// Props-ready prefab: <a {...externalLinkProps(url)}>label</a>
export function externalLinkProps(url) {
  const href = normalizeUrl(url);
  return {
    href: href || '#',
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: href ? undefined : (e) => e.preventDefault(),
  };
}
